/* AP 6.0 — zone A « coque » : méga-menu, tiroir de menu mobile, raccourci « / », puces de recherche vide, hauteur d'en-tête. */
(function () {
  if (window.__apShell) return; window.__apShell = true;
  var d = document, html = d.documentElement;
  var hoverMQ = window.matchMedia('(hover: hover) and (min-width: 990px)');

  /* hauteur de l'en-tête collant, exposée aux autres zones (--ap-hdr-h) */
  function setH() {
    var s = d.querySelector('.ap-hdr-section'); if (!s) return;
    var h = s.offsetHeight + 'px';
    html.style.setProperty('--ap-hdr-h', h); html.style.setProperty('--header-height', h);
  }

  /* ---------- méga-menu ---------- */
  function initMega() {
    var trig = d.querySelector('[data-ap-mega-trigger]'), mega = d.getElementById('ApMega');
    if (!trig || !mega) return;
    var t, loaded = false;
    function load() {
      if (loaded) return; loaded = true;
      mega.querySelectorAll('img[data-src]').forEach(function (img) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src; img.removeAttribute('data-src');
      });
    }
    function isOpen() { return mega.classList.contains('is-open'); }
    function open() { clearTimeout(t); load(); mega.classList.add('is-open'); trig.setAttribute('aria-expanded', 'true'); }
    function close() { clearTimeout(t); mega.classList.remove('is-open'); trig.setAttribute('aria-expanded', 'false'); }
    function later(fn, ms) { clearTimeout(t); t = setTimeout(fn, ms); }
    trig.addEventListener('mouseenter', function () { if (hoverMQ.matches) later(open, 60); });
    [trig, mega].forEach(function (el) {
      el.addEventListener('mouseleave', function () { if (hoverMQ.matches) later(close, 180); });
    });
    mega.addEventListener('mouseenter', function () { if (hoverMQ.matches) clearTimeout(t); });
    trig.addEventListener('click', function (e) { if (!isOpen()) { e.preventDefault(); open(); } });
    trig.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); open(); var a = mega.querySelector('a'); if (a) a.focus(); }
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { var inside = mega.contains(d.activeElement); close(); if (inside) trig.focus(); }
    });
    d.addEventListener('click', function (e) { if (isOpen() && !mega.contains(e.target) && !trig.contains(e.target)) close(); });
    mega.addEventListener('focusout', function (e) { if (e.relatedTarget && !mega.contains(e.relatedTarget) && e.relatedTarget !== trig) close(); });
    /* retour arrière (cache bfcache) : ne pas réafficher un panneau resté ouvert */
    window.addEventListener('pageshow', function (e) { if (e.persisted) close(); });
    /* ?menu=1 : ouverture forcée (captures, démo) */
    if (/[?&]ap_menu=1/.test(location.search) && window.innerWidth >= 990) open();
  }

  /* ---------- tiroir mobile ---------- */
  function initDrawer() {
    var mm = d.getElementById('ApMenu'); if (!mm) return;
    var opener = null, btns = d.querySelectorAll('[data-ap-menu-open]');
    function open(btn) {
      opener = btn || null;
      mm.removeAttribute('inert'); mm.classList.add('is-open'); html.classList.add('ap-lock');
      btns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var c = mm.querySelector('[data-ap-menu-close].ap-ib'); if (c) setTimeout(function () { c.focus(); }, 50);
    }
    function close() {
      if (!mm.classList.contains('is-open')) return;
      mm.classList.remove('is-open'); html.classList.remove('ap-lock'); mm.setAttribute('inert', '');
      btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (opener) opener.focus();
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { open(b); }); });
    mm.querySelectorAll('[data-ap-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    mm.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var p = mm.querySelector('.disclosure__button[aria-expanded="true"]'); if (!p) close(); }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(mm.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),summary'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches) close(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { opener = null; close(); } });
    if (/[?&]ap_menu=1/.test(location.search) && window.innerWidth < 990) open();
  }

  /* ---------- recherche : « / », puces populaires quand le champ est vide ---------- */
  function initSearch() {
    var form = d.querySelector('[data-ap-hsearch]'); if (!form) return;
    var input = form.querySelector('input[type=search]'), pop = form.querySelector('[data-ap-sg-pop]');
    function sync() { if (pop) pop.hidden = !(d.activeElement === input && !input.value.trim()); }
    if (pop) {
      input.addEventListener('focus', sync); input.addEventListener('input', sync);
      form.addEventListener('focusout', function () { setTimeout(function () { if (!form.contains(d.activeElement)) pop.hidden = true; }, 0); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { pop.hidden = true; input.blur(); } });
    }
    d.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      var a = d.activeElement, tag = a && a.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (a && a.isContentEditable)) return;
      if (input.offsetParent === null) return;
      e.preventDefault(); input.focus();
    });
  }

  function init() {
    setH(); initMega(); initDrawer(); initSearch();
    if (window.ResizeObserver) { var s = d.querySelector('.ap-hdr-section'); if (s) new ResizeObserver(setH).observe(s); }
    else window.addEventListener('resize', setH);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
